import { render } from "./leave-settings-model.vue?vue&type=template&id=31c7cfe3"
import script from "./leave-settings-model.vue?vue&type=script&lang=js"
export * from "./leave-settings-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__